<template>
	<div id="class-Request">
		<h6 class="title-section">Student Requests</h6>
    <b-tabs class="sm">
		<b-tab :active="TabClassRequest" @click="changeTab(0)">
			<template #title>
				{{$t('ClassRequest.titulo-tab')}} <span class="dot" v-show="totalRowsPublic>0">{{totalRowsPublic}}</span>
			</template>
        <div class="filters">
          <b-form-group :label="$t('ClassRequest.sub-titulo-tab')" style="width:69px">
				<CustomSelect
					@input="idValueSelectEventLevel"
					:options="optionsLevel"
					value="id"
					label="descripcion" 
					:default="$t('filter.text')"
					@change="getListSchedulePublicByTeacher()"
				/>
            <!-- <b-form-select v-model="selectedLevelPublic" :options="optionsLevel" value-field="id"  text-field="descripcion" @change="getListSchedulePublicByTeacher()">
              <template #first><b-form-select-option :value="null">{{$t('filter.text')}}</b-form-select-option> </template>
            </b-form-select> -->
          </b-form-group>
          <b-form-group :label="$t('ClassRequest.sub-titulo-tab-2')" style="width:92px">
				<CustomSelect
					@input="idValueSelectEventAge"
					:options="optionsAge"
					value="id"
					label="descripcion" 
					:default="$t('filter.text')"
					@change="getListSchedulePublicByTeacher()"
				/>
            <!-- <b-form-select v-model="selectedAgePublic" :options="optionsAge"  value-field="id"  text-field="descripcion" @change="getListSchedulePublicByTeacher()">
              <template #first><b-form-select-option :value="null">{{$t('filter.text')}}</b-form-select-option> </template>
            </b-form-select> -->
          </b-form-group>
          <b-form-group :label="$t('ClassRequest.sub-titulo-tab-3')" style="width:150px">
				<CustomSelect
					@input="idValueSelectEventStatus"
					:options="optionsStatus"
					value="id"
					label="descripcion" 
					:default="$t('filter.text')"
					@change="getListSchedulePublicByTeacher()"
				/>
            <!-- <b-form-select v-model="selectedStatusPublic" :options="optionsStatus"  value-field="id"  text-field="descripcion" @change="getListSchedulePublicByTeacher()">
              <template #first><b-form-select-option :value="null">{{$t('filter.text')}}</b-form-select-option> </template>
            </b-form-select> -->
          </b-form-group>
        </div>
			<b-table responsive  hover :items="itemsTablePublic" :busy="isBusy" :fields="fields" 
			:show-empty="true" id="table-request"  :tbody-transition-props="transProps"  primary-key="date" 
			style="white-space: pre-line;" :empty-text="$t('reusables.empty-text')">
				<template #table-busy>
					<div class="text-center text-danger my-2">
			<b-spinner class="align-middle"></b-spinner>
			<strong> {{$t('ClassRequest.Loading')}}...</strong>
					</div>
				</template>
				<template #head(strPercentageSchedules)="data">
					{{ data.label }}
					<i class="material-icons-outlined" v-b-tooltip.hover title="% match is the percentage of hours requested by the student that fit your availability. You must apply to teach at least 75% of the requested hours. " style="position:relative;top: 3px;left: 10px;">info</i>
				</template>
				<template #cell(strSubjects)="data">
					<p style="margin: 0px;">{{ data.item.flagPlanTest ? '(Trial class)': '' }}</p>
					<p>{{ data.value }}</p>
				
				</template>
				<template #cell(strPercentageSchedules)="data">
					<span v-if="data.item.flagAvailability">
						<b-link class="bold" @click="irDetalle(data.item.id, data.item,1, data.item. percentageSchedules)">{{$t('ClassRequest.text.1')}}</b-link>
						<div v-if="data.item.showPercentage">
							<label class="bold" v-if="(data.item.percentageSchedules !=statusSchudule.ACCEPTED || data.item.percentageSchedules !=statusSchudule.SUBMITTED_PROPOSAL)"
									:style="[parseFloat(data.item.percentageSchedules)==parseFloat(colorStyle.COMPLETED.value) ?	{color:colorStyle.COMPLETED.color} :
								parseFloat(data.item.percentageSchedules)>=parseFloat(colorStyle.INTERMEDIATED.value)?{color:colorStyle.INTERMEDIATED.color} :
								{color:colorStyle.INCOMPLETED.color}]">{{ data.value }}
							</label>
						</div>
					</span>
					<span v-else>
							<b-link to="/teacher/schedule" class="bold">You need to schedule your availability</b-link>
							<!-- <div v-if="data.item.showPercentage">
							<label class="bold" v-if="(data.item.percentageSchedules !=statusSchudule.ACCEPTED || data.item.percentageSchedules !=statusSchudule.SUBMITTED_PROPOSAL)"
									:style="[parseFloat(data.item.percentageSchedules)==parseFloat(colorStyle.COMPLETED.value) ?	{color:colorStyle.COMPLETED.color} :
								parseFloat(data.item.percentageSchedules)>=parseFloat(colorStyle.INTERMEDIATED.value)?{color:colorStyle.INTERMEDIATED.color} :
								{color:colorStyle.INCOMPLETED.color}]">{{ data.value }}</label>
							</div> -->
					</span>
					
				</template> 
				<template #cell(typeScheduleName)="data">
					<span class="bold">{{data.value}}</span>
					<span class="d-block" style="font-size: 12px" v-if="data.item.typeScheduleValue == statusSchudule.ACCEPTED || data.item.typeScheduleValue == statusSchudule.SUBMITTED_PROPOSAL ">{{ $t('ClassRequest.text.2')}}</span>
				</template>
			</b-table>
			<div class="overflow-auto content-pagination">
          <b-pagination
          v-model="currentPagePublic"
          :total-rows="totalRowsPublic"
          :per-page="perPagePublic"
          aria-controls="my-table"
          ></b-pagination>
            1-10 / {{totalRowsPublic}} {{$t('ClassRequest.text.3')}}
				</div>
		</b-tab>
		
		<b-tab :active="!TabClassRequest" @click="changeTab(1)">
				<template #title>
					{{$t('ClassRequest.titulo-tab-2')}} <span class="dot" v-show="totalRowsPrivate>0">{{totalRowsPrivate}}</span>
				</template>
        <div class="filters">
          <b-form-group :label="$t('ClassRequest.sub-titulo-tab')" style="width:69px">
			 <CustomSelect
					@input="idValueSelectEventPrivateLevel"
					:options="optionsLevel"
					value="id"
					label="descripcion" 
					:default="$t('filter.text')"
					@change="getListSchedulePrivateByTeacher()"
				/>
            <!-- <b-form-select v-model="selectedLevelPrivate" :options="optionsLevel" value-field="id"  text-field="descripcion" @change="getListSchedulePrivateByTeacher()">
              <template #first><b-form-select-option :value="null">{{$t('filter.text')}}</b-form-select-option> </template>
            </b-form-select> -->
          </b-form-group>
          <b-form-group :label="$t('ClassRequest.sub-titulo-tab-2')" style="width:92px">
			  <CustomSelect
					@input="idValueSelectEventPrivateAge"
					:options="optionsAge"
					value="id"
					label="descripcion" 
					:default="$t('filter.text')"
					@change="getListSchedulePrivateByTeacher()"
				/>
            <!-- <b-form-select v-model="selectedAgePrivate" :options="optionsAge"  value-field="id"  text-field="descripcion" @change="getListSchedulePrivateByTeacher()">
              <template #first><b-form-select-option :value="null">{{$t('filter.text')}}</b-form-select-option> </template>
            </b-form-select> -->
          </b-form-group>
          <b-form-group :label="$t('ClassRequest.sub-titulo-tab-3')" style="width:150px">
			  <CustomSelect
					@input="idValueSelectEventPrivateStatus"
					:options="optionsStatus"
					value="id"
					label="descripcion" 
					:default="$t('filter.text')"
					@change="getListSchedulePrivateByTeacher()"
				/>
            <!-- <b-form-select v-model="selectedStatusPrivate" :options="optionsStatus"  value-field="id"  text-field="descripcion" @change="getListSchedulePrivateByTeacher()">
              <template #first><b-form-select-option :value="null">{{$t('filter.text')}}</b-form-select-option> </template>
            </b-form-select> -->
          </b-form-group>
        </div>
				<b-table responsive  hover :items="itemsTablePrivate"  :busy="isBusyPrivate"  :fields="fields" :show-empty="true" 
				id="table-request"  :tbody-transition-props="transProps" 
				 primary-key="date" style="white-space: pre-line;" :empty-text="$t('reusables.empty-text')">
					<template #table-busy>
						<div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong> {{$t('ClassRequest.Loading')}}...</strong>
						</div>
					</template>
					<template #head(strPercentageSchedules)="data">
						{{ data.label }}
						<i class="material-icons-outlined" v-b-tooltip.hover :title="$t('title.12')" style="position: relative;top: 3px;left: 10px;">info</i>
					</template>
					<template #cell(strSubjects)="data">
						<span v-if="data.item.flagPlanTest" style="display: flex;justify-content: center;align-items: center;justify-content: center;">
							<span class="material-icons-outlined" style="font-size: 15px;">turned_in</span>
							<p style="margin: 0px;">{{`${$t('reusables.test-class')}`}}</p>
						</span>
					
						<p>{{ data.value }}</p>
					
					</template>
				
					<template #cell(strPercentageSchedules)="data">
						<span v-if="data.item.flagAvailability">
								<b-link  class="bold" @click="irDetalle(data.item.id,data.item,2, data.item.percentageSchedules)">{{$t('ClassRequest.text.1')}}</b-link>
							<div v-if="data.item.showPercentage">
								<label class="bold" v-if="(data.item.percentageSchedules !=statusSchudule.ACCEPTED || data.item.percentageSchedules !=statusSchudule.SUBMITTED_PROPOSAL)"
								:style="[parseFloat(data.item.percentageSchedules)==parseFloat(colorStyle.COMPLETED.value) ?	{color:colorStyle.COMPLETED.color} :
							parseFloat(data.item.percentageSchedules)>=parseFloat(colorStyle.INTERMEDIATED.value)?{color:colorStyle.INTERMEDIATED.color} :
							{color:colorStyle.INCOMPLETED.color}]">{{ data.value }}</label>
							</div>
						
						</span>
						<span v-else>
							<b-link to="/teacher/schedule" class="bold">You need to schedule your availability</b-link>
							<div v-if="data.item.showPercentage">
								<label class="bold" v-if="(data.item.percentageSchedules !=statusSchudule.ACCEPTED || data.item.percentageSchedules !=statusSchudule.SUBMITTED_PROPOSAL)"
								:style="[parseFloat(data.item.percentageSchedules)==parseFloat(colorStyle.COMPLETED.value) ?	{color:colorStyle.COMPLETED.color} :
							parseFloat(data.item.percentageSchedules)>=parseFloat(colorStyle.INTERMEDIATED.value)?{color:colorStyle.INTERMEDIATED.color} :
							{color:colorStyle.INCOMPLETED.color}]">{{ data.value }}</label>
							</div>
						</span>
					
					</template>
					<template #cell(typeScheduleName)="data">
						<span class="bold">{{data.value}}</span>
						<span class="d-block" style="font-size: 12px" v-if="data.item.typeScheduleValue == statusSchudule.ACCEPTED || data.item.typeScheduleValue == statusSchudule.SUBMITTED_PROPOSAL ">{{$t('ClassRequest.text.2')}}</span>
					</template>
				</b-table>
				<div class="overflow-auto content-pagination">
          <b-pagination
            v-model="currentPagePrivate"
            :total-rows="totalRowsPrivate"
            :per-page="perPagePrivate"
            aria-controls="my-table"
          ></b-pagination>
            {{currentPagePrivate}}-10 / {{totalRowsPrivate}} {{$t('ClassRequest.text.3')}}
			  </div>
			</b-tab>
		</b-tabs>
		  <!--:key="`request-modal-calendar`" -->
		<viewSchedule :showActions="true" ref="modalCalendar"  @updateScheduleClassRequest="updateListStrudent"  />
	</div>
</template>

<script>

import CustomSelect from "@/components/form/select";
import viewSchedule from "@/components/modals/view-schedule";
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";

import * as Constants from "@/assets/js/appConstants";

export default {
	components: {
      viewSchedule,
	  CustomSelect
    },
	data() {
      return {
		lang: localStorage.getItem('lang'),
		isTabActive:true,
		isBusyPrivate:false,
		isBusy : false,
		colorStyle:Constants.PERCENTAGE,
		statusSchudule:Constants.STATUS_SCHEDULE,
		changingValue:0,
		perPagePublic: 10, // numero que se muestra en la paginación
    	currentPagePublic: 1, //pagina actual 
		perPagePrivate: 10, // numero que se muestra en la paginación
    	currentPagePrivate: 1, //pagina actual 
		transProps: {
		// Transition name
			name: 'flip-list'
		},
		totalRowsPublic:0, 
		totalRowsPrivate:0, 
		fields: [
			// {key: 'id', label: '#'},
			{key: 'requestDate', label: this.$t('table-request-class.requestDate'), thClass: 'text-center', tdClass: 'text-center', thStyle:{width:"9%"}},
			{key: 'strFullName', label: this.$t('table-request-class.strFullName'), thClass: 'text-center', tdClass: 'text-center',thStyle:{width:"15%"}},
			{key: 'level', label:this.$t('table-request-class.level'),thStyle:{width:"10%"}},
			{key: 'strAge', label: this.$t('table-request-class.strAge'),thClass: 'text-center'},
			{key: 'strSubjects', label: this.$t('table-request-class.strSubjects'), thClass: 'text-center',tdClass: 'text-center',thStyle:{width:"22%"}},
			{key: 'pay', label:this. $t('table-request-class.pay')},
			{key: 'strPercentageSchedules', label: this.$t('table-request-class.strPercentageSchedules'),thClass: 'text-center', sortable: false,thStyle:{width:"15%"} },
			{key: 'typeScheduleName', label: this.$t('table-request-class.typeScheduleName'),thStyle:{width:"16%"}}
	     	],
    	itemsTablePublic:[],
		itemsTablePrivate:[],
		optionsStatus : [],
		selectedLevelPrivate: null,
     	optionsLevel:[],
		selectedAgePrivate: null,
    	optionsAge: [],
		selectedStatusPrivate: null,
		selectedLevelPublic: null,
		selectedAgePublic: null,
		selectedStatusPublic: null, 
		schedulesOptionId: Constants.SCHEDULES_OPTIONS.SOLICITUD_MASIVA,
        events: [],
  
      }
    },
	computed: {
        teacherId: {
            get() {
                return this.$store.state.user.personTeacherId;
            }
        },
		TabClassRequest: {
			get(){
				return this.$store.state.classRequestTab
			},
			set(value) {
				this.$store.dispatch('updateClassRequestTab',value);
      		}
		}
		
    },
    created() {
		this.getListCombos();
		this.getListSchedulePublicByTeacher();
		this.getListSchedulePrivateByTeacher()
  	},
	updated(){
		if(this.$store.state.user != null){
			this.$store.state.user.totalClassRequest =  this.totalRowsPublic + this.totalRowsPrivate ;
			this.$store.commit('mutateUser', this.$store.state.user);
		}
	},
	watch: {
		currentPagePublic: {
			handler: function(value) {
				this.getListSchedulePublicByTeacher();
			}
		},
		currentPagePrivate: {
			handler: function(value) {
				this.getListSchedulePrivateByTeacher();
			}
		}
	},
	mounted(){
	  this.$root.$on('updateViewRequestClass', (value) => { 
     
            this.flagUpdate = value;
      

            if(this.flagUpdate){
              
                this.updateListStrudent();
          
    
            }

     
     
        })
       
	},
  	methods:{
		idValueSelectEventLevel(event) {
			this.selectedLevelPublic = event;
		},
		idValueSelectEventAge(event){
			this.selectedAgePublic = event;
		},
		idValueSelectEventStatus(event){
			this.selectedStatusPublic = event;
		},
		idValueSelectEventPrivateLevel(event){
			this.selectedLevelPrivate = event;
		},
		idValueSelectEventPrivateAge(event){
			this.selectedLevelPrivate = event;
		},
		idValueSelectEventPrivateStatus(event){
			this.selectedStatusPrivate = event;
		},
		changeTab(indexTab){
	
			this.TabClassRequest =  true;
			if(indexTab!=0){
				this.TabClassRequest = false;
			}

		},
		updateListStrudent(){
			this.itemsTablePublic = []
			this.itemsTablePrivate = []
			this.getListSchedulePublicByTeacher();
			this.getListSchedulePrivateByTeacher()
		},
		irDetalle(scheduleCounteProposalId,dataStudent,type, percentage){
			this.$bvModal.show('modal-schedule');
			this.$refs.modalCalendar.getId(scheduleCounteProposalId,dataStudent,type, percentage);
		},
		getListCombos() {
			baseInstanceAxios
				.get(
				this.apiURL +
					"/resources/GroupScheduleCounterProposal/GetScheduleCombos"
				)
				.then((response) => {
				if (response.data) {
					if (response.data.entity) {
					response.data.entity.listCatalogs.forEach(element => {
						if(element.valor==Constants.OPTION_STATUS.VALUE1.VALUE){
							element.descripcion = this.lang == "en" ? Constants.OPTION_STATUS.VALUE1.EN :  element.descripcion
						}
						if(element.valor==Constants.OPTION_STATUS.VALUE2.VALUE){
							element.descripcion = this.lang == "en" ? Constants.OPTION_STATUS.VALUE2.EN :  element.descripcion
						}
						if(element.valor==Constants.OPTION_STATUS.VALUE3.VALUE){
							element.descripcion = this.lang == "en" ? Constants.OPTION_STATUS.VALUE3.EN :  element.descripcion
						}
					
						if(element.valor==Constants.OPTION_STATUS.VALUE4.VALUE){
							element.descripcion = this.lang == "en" ? Constants.OPTION_STATUS.VALUE4.EN :  element.descripcion
						}
						if(element.valor==Constants.OPTION_STATUS.VALUE5.VALUE){
							element.descripcion = this.lang == "en" ? Constants.OPTION_STATUS.VALUE5.EN :  element.descripcion
						}
					});
					
					this.optionsLevel =response.data.entity.listLevelsByAbbreviation;
					this.optionsAge =response.data.entity.listSegments;
					this.optionsStatus =response.data.entity.listCatalogs;
					
					}
				} 
			});
		},
		getListSchedulePublicByTeacher() {
			 
			this.itemsTablePublic = []
			this.isBusy = true;
			let data = {
				LevelId:  this.selectedLevelPublic,
				AgeId: this.selectedAgePublic,
				TypeScheduleId: this.selectedStatusPublic,
				TeacherId : this.teacherId,
				SchedulesOptionId : Constants.SCHEDULES_OPTIONS.SOLICITUD_MASIVA,  
				timezone_name: this.$store.state.user.timeZoneName,
				Page : this.currentPagePublic,
				Size : this.perPagePublic
    		}
		
            baseInstanceAxios
                .get(
				 `${this.apiURL}/Resources/GroupsCoursesLessons/ListScheduleByTeacherPublicPrivateRequest`,
				  	{
						params: data
					}
				 )
                .then(response => {
				
				if(response.data != null && response.data.list != null){
					response.data.list.forEach(element => {
						//console.log("element.typeSchedule: ",element.typeSchedule)
						let nameStatus = null
						if(element.typeSchedule.value==Constants.OPTION_STATUS.VALUE1.VALUE){
							nameStatus =  Constants.OPTION_STATUS.VALUE1.EN 
						}
						if(element.typeSchedule.value==Constants.OPTION_STATUS.VALUE2.VALUE){
							nameStatus =  Constants.OPTION_STATUS.VALUE2.EN 
						}
						if(element.typeSchedule.value==Constants.OPTION_STATUS.VALUE3.VALUE){
							nameStatus = Constants.OPTION_STATUS.VALUE3.EN
						}
					
						if(element.typeSchedule.value==Constants.OPTION_STATUS.VALUE4.VALUE){
							nameStatus = Constants.OPTION_STATUS.VALUE4.EN
						}
						if(element.typeSchedule.value==Constants.OPTION_STATUS.VALUE5.VALUE){
							nameStatus =  Constants.OPTION_STATUS.VALUE5.EN 
						}
						let value = parseInt(element.typeSchedule.value)
						let json = {
							flagPlanTest : element.flagPlanTest,
							id : element.id,
							flagAvailability : element.flagAvailability,
							personTeacherId : element.personTeacherId,
							groupScheduleProposalId : element.groupScheduleProposalId,
							typeScheduleName : nameStatus,
							typeScheduleId : element.typeSchedule.id,
							typeScheduleValue : value ,
							requestDate : element.flagPlanTest ? element.requestDateString_EN : element.requestDateString_EN, //CHC: no he visto en la doc que se indique que no se muestre la fecha si es clase de prueba
							percentageSchedules : element.percentageSchedules,
							strPercentageSchedules : element.strPercentageSchedules,
							strSubjects :element.listStrSubjects_EN ? element.listStrSubjects_EN.replaceAll('[br]','\n')  : "",
							groupsId : element.groupsId,
							flagTypeGroup: element.flagTypeGroup,
							codeGroup: element.groupsPlan ? element.groupsPlan.group.code : "",
							levelGroup: element.groupsPlan ? element.groupsPlan.group ? element.groupsPlan.group.levels ? element.flagTypeGroup ? element.groupsPlan.group.levels.abbreviation + " - " + element.groupsPlan.group.levels.name : "" : "" : "" : "",
							strFullNameList:element.strFullNameList,
							strFullName : element.flagTypeGroup? element.strFullNameList.replaceAll(',[br]','\n') :element.strFullNameList  ,
							strAge : element.flagTypeGroup? element.strAgeList.replaceAll(',[br]','\n') : element.strAgeList,
							level : element.flagTypeGroup? element.strAbbreviationList.replaceAll(',[br]','\n') : element.strAbbreviationList,
							//pay : element.flagTypeGroup ? element.groupsPlan.amount: element.groupsPlan.strPrice,
							pay : element.groupsPlan ? element.groupsPlan.strPrice : "",
							typeProposalId: element.typeProposal.id,
							photoStundet :element.personsPhoto,
							className :element.className,
							levelAbbreviationGroup :element.levelAbbreviationGroup,
							showPercentage : value==Constants.STATUS_SCHEDULE.ACCEPTED ||  value==Constants.STATUS_SCHEDULE.SUBMITTED_PROPOSAL ? false : true
						}
					
						this.itemsTablePublic.push(json)
						
					});
				
					this.totalRowsPublic =  response.data.rows;
					this.isBusy = false;

	
				}
                });
							
        },
		getListSchedulePrivateByTeacher(){
			 
			this.itemsTablePrivate = []
			this.isBusyPrivate = true;
			let data = {
				LevelId: this.selectedLevelPrivate,
				AgeId: this.selectedAgePrivate,
				TypeScheduleId: this.selectedStatusPrivate,
				TeacherId : this.teacherId,
				SchedulesOptionId : Constants.SCHEDULES_OPTIONS.SOLICITUD_DIRECTA,
				timezone_name: this.$store.state.user.timeZoneName,
				Page : this.currentPagePrivate,
				Size : this.perPagePrivate
    		}
			 
            baseInstanceAxios
                .get(
				 `${this.apiURL}/Resources/GroupsCoursesLessons/ListScheduleByTeacherPublicPrivateRequest`,
				  	{
						params: data
					}
				 )
                .then(response => {
	
				if(response.data != null && response.data.list != null){
					response.data.list.forEach(element => {
						
						let nameStatus = null
						if(element.typeSchedule.value==Constants.OPTION_STATUS.VALUE1.VALUE){
							nameStatus =  Constants.OPTION_STATUS.VALUE1.EN 
						}
						if(element.typeSchedule.value==Constants.OPTION_STATUS.VALUE2.VALUE){
							nameStatus =  Constants.OPTION_STATUS.VALUE2.EN 
						}
						if(element.typeSchedule.value==Constants.OPTION_STATUS.VALUE3.VALUE){
							nameStatus = Constants.OPTION_STATUS.VALUE3.EN
						}
					
						if(element.typeSchedule.value==Constants.OPTION_STATUS.VALUE4.VALUE){
							nameStatus = Constants.OPTION_STATUS.VALUE4.EN
						}
						if(element.typeSchedule.value==Constants.OPTION_STATUS.VALUE5.VALUE){
							nameStatus =  Constants.OPTION_STATUS.VALUE5.EN 
						}
						let value = parseInt(element.typeSchedule.value)
						let json = {
							flagPlanTest : element.flagPlanTest,
							id : element.id,
							flagAvailability : element.flagAvailability,
							personTeacherId : element.personTeacherId,
							groupScheduleProposalId : element.groupScheduleProposalId,
							typeScheduleName : nameStatus,
							typeScheduleId : element.typeSchedule.id,
							typeScheduleValue : value ,
							requestDate : element.flagPlanTest ? element.requestDateString_EN : element.requestDateString_EN, //CHC: no he visto en la doc que se indique que no se muestre la fecha si es clase de prueba
							percentageSchedules : element.percentageSchedules,
							strPercentageSchedules : element.strPercentageSchedules,
							strSubjects : element.listStrSubjects_EN ? element.listStrSubjects_EN.replaceAll('[br]','\n') : "" ,
							groupsId : element.groupsId,
							flagTypeGroup: element.flagTypeGroup,
							codeGroup: element.groupsPlan ? element.groupsPlan.group.code : "",
							levelGroup: element.groupsPlan ? element.groupsPlan.group ? element.groupsPlan.group.levels ? element.flagTypeGroup ? element.groupsPlan.group.levels.abbreviation + " - " + element.groupsPlan.group.levels.name : "" : "" : "" : "",
							strFullNameList:element.strFullNameList,
							strFullName : element.flagTypeGroup? element.strFullNameList.replaceAll(',[br]','\n') :element.strFullNameList  ,
							strAge : element.flagTypeGroup? element.strAgeList.replaceAll(',[br]','\n') : element.strAgeList,
							level : element.flagTypeGroup? element.strAbbreviationList.replaceAll(',[br]','\n') : element.strAbbreviationList,
							//pay : element.flagTypeGroup ? element.groupsPlan.amount: element.groupsPlan.strPrice,
							pay : element.groupsPlan ? element.groupsPlan.strPrice : "",
							typeProposalId: element.typeProposal.id,
							photoStundet :element.personsPhoto,
							className :element.className,
							levelAbbreviationGroup :element.levelAbbreviationGroup,
							showPercentage : value==Constants.STATUS_SCHEDULE.ACCEPTED ||  value==Constants.STATUS_SCHEDULE.SUBMITTED_PROPOSAL ? false : true

						}
						this.itemsTablePrivate.push(json)
						
					});
				
					this.totalRowsPrivate=  response.data.rows;
					this.isBusyPrivate = false;
				}
                });
		}
  }
}
</script>

<style>

</style>